import { z } from "zod"

export const Pagination = z.object({
  cursor: z.preprocess(Number, z.number()).default(0),
  take: z.preprocess(Number, z.number()).default(100),
})

export type Pagination = z.infer<typeof Pagination>
